
export const MODIFIED_BY = {
    supplier: 'Job Supplier',
    repairer: 'Repairer',
};

export const SERVICE_STATUS = {
    'Open': 'open', // MTODO: same as creation?
    'Accepted': 'accepted',
    'InProgress': 'in progress',
    'Completed': 'completed',
    'Closed': 'closed', // MTODO
    'Canceled': 'canceled',
    'Declined': 'declined',
};

export const SUPPLEMENT_STATUS = {
    'PendingApproval': 'pending approval',
    'Approved': 'approved',
    'Rejected': 'rejected',
};

export const SUPPLEMENT_TYPE = {
    'NewWork': 'NewWork',
    'ExistingWork': 'ExistingWork',
    'Rework': 'rework',
};

export const isSame = (serviceStatus, refStatus) => serviceStatus && refStatus && serviceStatus.toLowerCase() === refStatus.toLowerCase();

export const capitalizeWords = (sentence) => {
    if (!sentence?.length) return sentence;
    return sentence.split(' ').map((w) => `${w[0].toLocaleUpperCase()}${w.slice(1)}`).join(' ');
};

export const formatPrice = (price) => (new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price));

export const formatMonthDayYear = (date) => {
    const day = date.getDate();

    const getSuffix = () => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    return ` ${date.toLocaleString('default', { month: 'long' })} ${day}${getSuffix()}, ${date.getFullYear()}`;
};